// extracted by mini-css-extract-plugin
var _1 = "PJiKbJWUAyc5aKBwCsTg";
export { _1 as "frameHeight" }
